import { User } from "oidc-client";
import { parseBackendData, isValidBackend, BackendData } from "./backendDataParser";
import { ClientOptions, getIdentityClientSettings, SelectClient } from "./localStorage";

export function getBackendDataListIDM(user: User): BackendData[] {
  let backendDataList: BackendData[] = [];

  const backendValue: string[] | string = user.profile.backend ? user.profile.backend : [];

  if (Array.isArray(backendValue)) {
    backendDataList = backendValue
      .map(backendString => parseBackendData(backendString))
      .filter(backendData => isValidBackend(backendData));
  }
  else {
    const backendData = parseBackendData(backendValue);

    if (isValidBackend(backendData)) {
      backendDataList.push(backendData);
    }
  }

  return backendDataList;
};

export function setClientOptions(backendDataList: BackendData[]) {
  if (backendDataList && backendDataList.length > 0) {
    // Set client options
    ClientOptions(backendDataList, 'clientOptions');

    const backendLocalStorageValue = localStorage.getItem('selectedClient');

    if (!backendLocalStorageValue) {
      // Select default value if its unset
      SelectClient(backendDataList[0], 'selectedClient');

      return backendDataList[0];
    }

    const selectedClient: BackendData = JSON.parse(backendLocalStorageValue);

    const selectedClientInOptions = backendDataList.find(backend => backend.name === selectedClient.name);

    if (!selectedClientInOptions) {
      SelectClient(backendDataList[0], 'selectedClient');

      return backendDataList[0];
    }

    return selectedClient;
  }

  throw new Error("Backend data list is empty.")
};